import AboutPage from 'src/pages/about';
import ComingSoon from 'src/pages/comingSoon';
import ContactUs from 'src/pages/contactUs';
import LandingPage from '../pages/landingPage';
import NotFoundPage from '../pages/notFoundPage';
import PrivacyPolicy from 'src/pages/privacyPolicyPage';
import { Routes } from 'src/utils/enums';
import { createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter([
    {
        element: <LandingPage />,
        path: '/',
    },
    {
        element: <AboutPage />,
        path: Routes.ABOUT,
    },
    {
        element: <ComingSoon />,
        path: Routes.COMING_SOON,
    },
    {
        element: <ContactUs />,
        path: Routes.CONTACT_US,
    },
    {
        element: <PrivacyPolicy />,
        path: Routes.PRIVACY_POLICY,
    },
    {
        element: <NotFoundPage />,
        path: '*',
    },
]);
